export enum DeviceSystem {
  Web = 'WEB',
}
